// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";
import { useLanguage } from "../i18n";

function SEO({ title, description, url, image }) {
  const { t } = useLanguage();
  const defaultTitle = t("seo.defaultTitle");
  const defaultDescription = t("seo.defaultDescription");
  const defaultUrl = "https://fixanor.com";
  const defaultImage = "https://fixanor.com/images/hero-image-webp.webp";

  return (
    <Helmet>
      {/* Title & Description */}
      <title>{title ? `${title} | ${defaultTitle}` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />

      {/* Canonical URL */}
      <link rel="canonical" href={url || defaultUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:url" content={url || defaultUrl} />
      <meta property="og:image" content={image || defaultImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />

      {/* Mobile viewport */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Charset */}
      <meta charSet="utf-8" />
    </Helmet>
  );
}

export default SEO;
